import { NgModule } from '@angular/core';
import { NgSlimScrollModule } from 'ngx-slimscroll';

@NgModule({
  imports: [NgSlimScrollModule],
  exports: [NgSlimScrollModule]
})
export class ScrollModule { }